import { Button } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';
import { downloadFile } from 'Utils';
import Error from 'Components/Error';
import React from 'react';
import styled from 'styled-components';

import ClearFile from '../components/ClearFile';
import FieldError from '../components/FieldError';
import HiddenLink from '../components/HiddenLink';

const Container = styled.div`
  padding: 1.875rem 0;
  height: 100%;
  border-bottom: 2px solid ${({ theme }) => theme.palette.blue.light};
`;

const ContainerShortlisted = styled.div`
  padding-top: 1.875rem;
  height: 100%;
  border-top: 2px solid ${({ theme }) => theme.palette.blue.light};
  border-bottom: 2px solid ${({ theme }) => theme.palette.blue.light};
`;

const Heading = styled.h2`
  font-size: 1rem;
  margin: 0.625rem 0;
`;

const CustomButton = styled(Button)`
  &&& {
    background: #fff;
    border: 1px solid ${({ theme }) => theme.palette.primary.main};
    font-weight: 600;
    font-size: 1rem;
    text-transform: uppercase;
    position: relative;
  }
`;

const FileInput = styled.input.attrs({
  type: 'file',
})`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 1000;
`;

const File = styled.div`
  display: flex;
  align-items: center;
`;

const FileLink = styled.button`
  &&& {
    background: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    font-size: 0.875rem;
    margin-left: 0.5rem;

    &:focus {
      outline: 0;
    }

    &:hover {
      border-bottom: 1px solid ${({ theme }) => theme.palette.blue.light};
      background: transparent !important;
      cursor: pointer;
    }
  }
`;

const FileName = styled.div`
  font-size: 0.875rem;
`;

const FileContainer = styled.div`
  padding: 1.5625rem 0 0;
`;
class AddQuotation extends React.PureComponent {
  file = React.createRef();

  state = {
    error: null,
  };

  componentDidCatch(error, info) {
    this.setState({
      error,
    });
  }

  onFileDownload = downloadFile;

  onDownloadError = err => {
    this.setState({
      error: err,
    });
  };
  onErrorCancel = err => {
    this.setState({
      error: null,
    });
  };

  renderUploadButtonsIfShortlisted = (
    onAddQuotation,
    onRemoveQuotation,
    quotation,
    error,
    isTicketExpired,
    isSlipDiscarded
  ) => {
    return (
      <React.Fragment>
        <Error onCancel={this.onErrorCancel} errors={this.state.error} />
        <Heading>
          <div>Add manufacturer budget pricing</div>
          {error ? <FieldError>{`*${error}`}</FieldError> : null}
        </Heading>
        <CustomButton
          component="div"
          disabled={isSlipDiscarded || Boolean(quotation) ? true : false}
        >
          <FileInput disabled={isSlipDiscarded} onChange={onAddQuotation} />
          UPLOAD DOCUMENT
        </CustomButton>
        <FileContainer>
          {Boolean(quotation) &&
          typeof quotation === 'object' &&
          quotation.assetId ? (
            <File>
              <FileCopy />
              <FileLink
                onClick={this.onFileDownload(
                  quotation.assetId,
                  this.file
                )(this.onDownloadError)}
              >
                {quotation.originalName}
              </FileLink>
              <HiddenLink
                innerRef={this.file}
                download={quotation.originalName}
              />
              <ClearFile
                onClick={onRemoveQuotation('quotation')}
                disabled={isSlipDiscarded}
              />
            </File>
          ) : Boolean(quotation) ? (
            <File>
              <FileCopy />
              <FileName>{quotation.name}</FileName>
              <ClearFile
                onClick={onRemoveQuotation('quotation')}
                disabled={isSlipDiscarded}
              />
            </File>
          ) : null}
        </FileContainer>
      </React.Fragment>
    );
  };

  render() {
    const {
      onAddQuotation,
      onRemoveQuotation,
      quotation,
      error,
      isTicketExpired,
      shortlisted = false,
      isSlipDiscarded,
    } = this.props;
    return (
      <React.Fragment>
        {!shortlisted ? (
          <Container>
            {this.renderUploadButtonsIfShortlisted(
              onAddQuotation,
              onRemoveQuotation,
              quotation,
              error,
              isTicketExpired,
              isSlipDiscarded
            )}
          </Container>
        ) : (
          <ContainerShortlisted>
            {this.renderUploadButtonsIfShortlisted(
              onAddQuotation,
              onRemoveQuotation,
              quotation,
              error,
              isTicketExpired,
              isSlipDiscarded
            )}
          </ContainerShortlisted>
        )}
      </React.Fragment>
    );
  }
}

export default AddQuotation;
